// extracted by mini-css-extract-plugin
module.exports = {"message":"AdditionalMessages_message__7a9xg"};